export type UsdLedgerDisplayCategory =
  | 'refund'
  | 'transaction_reversal'
  | 'balance_correction_debit'
  | 'balance_correction_credit';

export type UsdLedgerInitiatedBy = {
  kind: 'admin' | 'system';
  adminId: string | null;
  displayName: string;
};

export type UsdLedgerDisplayAudit = {
  reason: string | null;
  ticketId: string | null;
  initiatedBy: UsdLedgerInitiatedBy;
  originalTransactionId: string | null;
  reversalTransactionId: string | null;
};

export type UsdLedgerDisplayLink = {
  kind: 'usd_ledger' | 'payment_transaction';
  id: string;
  label: string;
};

export type UsdLedgerDisplayFields = {
  displayCategory?: UsdLedgerDisplayCategory | null;
  displayLabel?: string | null;
  audit?: UsdLedgerDisplayAudit | null;
  links?: UsdLedgerDisplayLink[] | null;
};

const BADGE_BY_CATEGORY: Record<UsdLedgerDisplayCategory, string> = {
  refund: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  transaction_reversal: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  balance_correction_debit: 'bg-amber-100 text-amber-900 border-amber-200',
  balance_correction_credit: 'bg-sky-100 text-sky-900 border-sky-200',
};

export function displayBadgeClass(category: UsdLedgerDisplayCategory | null | undefined): string {
  if (!category) return 'bg-slate-100 text-slate-800 border-slate-200';
  return BADGE_BY_CATEGORY[category] ?? 'bg-slate-100 text-slate-800 border-slate-200';
}

export function pickUsdLedgerDisplay(row: Record<string, unknown>): {
  displayLabel: string | null;
  displayCategory: UsdLedgerDisplayCategory | null;
  audit: UsdLedgerDisplayAudit | null;
  links: UsdLedgerDisplayLink[];
} {
  const displayLabel =
    typeof row.displayLabel === 'string' && row.displayLabel.trim()
      ? row.displayLabel.trim()
      : null;
  const displayCategory =
    typeof row.displayCategory === 'string'
      ? (row.displayCategory as UsdLedgerDisplayCategory)
      : null;
  const audit =
    row.audit && typeof row.audit === 'object' ? (row.audit as UsdLedgerDisplayAudit) : null;
  const links = Array.isArray(row.links) ? (row.links as UsdLedgerDisplayLink[]) : [];
  return { displayLabel, displayCategory, audit, links };
}

export function ledgerLinkToAdminPath(link: UsdLedgerDisplayLink): string | null {
  if (link.kind === 'payment_transaction') return `/transactions/${link.id}`;
  return null;
}
